<template>
 <h3>各期权公司规则</h3>
  <div>
    <div class="rules-container">
        <div v-for="(group, key) in rules" :key="key" class="rule-group">
          <h4>{{ getCompanyName(key) }}</h4>
          <div v-for="(rule, index) in group" :key="index" class="rule-item">
            {{ rule }}
          </div>
        </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'RulesPage',

  data() {
    return {
         rules: {
          huatai: [
            '【个股/ETF香草期权】若14：15前未指定出场方式或指定方式未能成交，默认按照14：30-14：57TWAP实际成交价结算',
            '【个股/ETF自动赎回】默认按照14：30-14：57TWAP结算',
            '【指数香草/自动赎回】默认按照收盘价结算'
          ],
          ziqi: [
            '1.起做规模：个股香草100W,股指300W。雪球个股200W，股指300W。ETF同个股规则。',
            '2.最早行权日：T+1',
            '3.敲出规则：以收盘价为标准，连续3日涨停/跌停（包括开仓当日），我方将强制行权了结。',
            '4.指令时间：表价不进入集合竞价，接受下单时间为9：30-14：45的交易时间。14：45后交易台不接受开平改指令。',
            '5.行权规则：期权到期日无其他指令，默认以收盘价了结。到期日指令接收到14：30，如14：30前未完成平仓，则自动转收盘价。'
          ],
          yinhe: [
            '1.三板不强平规则：2w+1% 1m+1.5% 2-3m+2% 4-6m+2.5%',
            '2.最早行权日：T+1',

          ]
        },
    }
  },
  methods: {
      getCompanyName(key) {
        return {
          huatai: '华泰规则',
          ziqi: '浙期规则',
          yinhe: '银河规则' // 根据实际公司名称调整
        }[key] || '未知规则';
      }
    }
}
</script>
<style>







.page-container {
  padding: 20px;
  max-width: 1200px;
  margin: 0 auto;
}

.title-section {
  margin-bottom: 30px;
}

.rules-container {
  background: #f8f9fa;
  border-radius: 8px;
  padding: 20px;
  margin-bottom: 40px;
}

.rule-group {
  margin-bottom: 25px;
}

.rule-group:last-child {
  margin-bottom: 0;
}

.rule-item {
  margin: 8px 0;
  font-size: 14px;
  line-height: 1.5;
}


</style>